import React from 'react';
import {useHeader} from '../../../../_metronic/layout';
import {useIntl} from 'react-intl';
import {StreetsProvider} from '../../_common/components/CitiesAndStreets';
import {SimpleDateRangeProvider} from "../SimpleDateRangeContext";
import {SimpleDateRange} from "../components/DashboardPageCharts/SimpleDateRange";
import {ExtendedDateRangeProvider} from "../ExtendedDateRangeContext";
import {ExtendedDateRange} from "../components/DashboardPageCharts/ExtendedDateRange";
import SimpleDateRangeFilters from "../components/DashboardPageFilter/components/SimpleDateRangeFilters";
import ExtendedDateRangeFilters from "../components/DashboardPageFilter/components/ExtendedDateRangeFilters";
import {InfoBoxesContextProvider} from '../InfoBoxesContext';
import InfoBoxes from '../components/DashboardPageInfoBoxes';
import Unit from '../../_common/components/Unit';
import styles from './styles.module.scss';

const DashboardPage = () => {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: 'dashboard-page-header',
    defaultMessage: 'Dashboard page'
  }));
  const intl = useIntl();

  return (
    <StreetsProvider>
      <InfoBoxesContextProvider>
        <InfoBoxes/>
      </InfoBoxesContextProvider>
      <SimpleDateRangeProvider>
        <Unit
          text={intl.formatMessage({
            id: `dashboard-page-simpleDateRange-filters-label`,
            defaultMessage: 'Time period'
          })}
          icon={'/media/common/Date_green.svg'}
          customClassnames={styles.dateRangeContainer}
          customHeaderClassnames={'justify-content-center'}
        >
          <SimpleDateRangeFilters/>
          <SimpleDateRange/>
        </Unit>
      </SimpleDateRangeProvider>
      <ExtendedDateRangeProvider>
        <Unit
          text={[
            intl.formatMessage({
              id: `dashboard-page-extendedDateRange-filters-scale-label`,
              defaultMessage: 'Time period'
            }),
            intl.formatMessage({
              id: `dashboard-page-extendedDateRange-filters-extendedDateRange-label`,
              defaultMessage: 'Date range'
            })
          ].join(' / ')
          }
          icon={'/media/common/Date_green.svg'}
          customClassnames={styles.dateRangeContainer}
          customHeaderClassnames={'justify-content-center'}
        >
          <ExtendedDateRangeFilters/>
          <ExtendedDateRange/>
        </Unit>
      </ExtendedDateRangeProvider>
    </StreetsProvider>
  );
};

export default DashboardPage;
